<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "UnsubscribeOnboarding" });
import { Modal } from "../../../../components/index.js";
import { Heading, Paragraph } from "../../../../typography/index.js";
</script>

<Modal hash = '#unsubscribe-onboarding'>
    <Heading size = 'sm'>Sad to see you go!</Heading>
    <Paragraph>
        We will no longer send you any notifications pertaining to smatch and our offers.
    </Paragraph>
    <Paragraph>
        If you change your mind in the meantime or if you find yourself in need of access
        to premium brands, don't hesitate to get in touch and we'll be happy to onboard you
        into our platform and share new opportunities with you.
    </Paragraph>
    <Paragraph>
        If there's anything we can do better, please let us know!
    </Paragraph>
</Modal>